import { addToCart, changeLine, renderCartDrawer, CartError } from './b-cart-api.js';

const showError = (target, err) => {
  const box = target.closest('.b-cart-extras')?.querySelector('.b-cart-extras__error');
  if (!box) return;
  box.textContent = err instanceof CartError ? err.message : 'No pudimos actualizar el carrito. Intenta de nuevo.';
  box.hidden = false;
};

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cart-add]');
  if (!button) return;
  button.disabled = true;
  try {
    renderCartDrawer(await addToCart([{ id: Number(button.dataset.cartAdd), quantity: 1 }]));
  } catch (err) {
    showError(button, err);
    button.disabled = false;
  }
});

document.addEventListener('change', async (event) => {
  const box = event.target.closest('[data-gift-wrap]');
  if (!box) return;
  box.disabled = true;
  try {
    const data = box.checked
      ? await addToCart([{ id: Number(box.dataset.giftWrap), quantity: 1 }])
      : await changeLine(box.dataset.lineKey, 0);
    renderCartDrawer(data);
  } catch (err) {
    box.checked = !box.checked;
    showError(box, err);
    box.disabled = false;
  }
});

/* Aviso "Agregado · {producto}" dentro del carrito lateral */
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source, cartData }) => {
    if (source === 'cart-items') return;
    const title = cartData?.product_title ?? cartData?.items?.[0]?.product_title;
    if (!title) return;
    requestAnimationFrame(() => {
      const toast = document.querySelector('#CartDrawer .b-toast');
      if (!toast) return;
      toast.querySelector('[data-toast-text]').textContent = `Agregado · ${title}`;
      toast.hidden = false;
      clearTimeout(toast._t);
      toast._t = setTimeout(() => { toast.hidden = true; }, 3000);
    });
  });
}

/* Escape cierra el carrito aunque el foco aún no haya entrado al panel (animación en curso) */
document.addEventListener('keyup', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelector('cart-drawer.active')?.close();
});
